import { request } from "./api";
import type { WaitingRoom, WaitingRoomRequest, WaitingRoomResponse } from "./types";
import {
  getWaitingRoomCache,
  setWaitingRoomCache,
  isInWaitingRoom,
} from "../utils/waitingRoomCache";

// POST /api/WaitingRooms
export async function createWaitingRoom(
  data: WaitingRoomRequest
): Promise<WaitingRoomResponse> {
  const res = await fetch("/api/WaitingRooms", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Error ${res.status}: ${errorText}`);
  }

  return (await res.json()) as WaitingRoomResponse;
}

// POST /api/WaitingRooms/join
export async function joinWaitingRoom(): Promise<WaitingRoom> {
  if (isInWaitingRoom()) {
    const cachedData = getWaitingRoomCache();
    if (cachedData) {
      throw new Error(
        `Ya estás en la sala de espera con el código ${cachedData.code}. Puedes unirte nuevamente en 2 horas.`
      );
    }
  }

  const result = await request<WaitingRoom>("/WaitingRooms/join", {
    method: "POST",
  });

  if (result.code && result.id) {
    setWaitingRoomCache({
      code: result.code,
      id: result.id,
      isPriority: result.isPriority || false,
    });
  }

  return result;
}

// PATCH /api/waitingroom/{id}/assign-cubicle
export async function assignCubicle(
  id: number,
  cubicleId: number
): Promise<{ id: number; message: string }> {
  const token = localStorage.getItem("accessToken");
  
  const res = await fetch(`/api/waitingroom/${id}/assign-cubicle`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ cubicleId }),
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(`Error ${res.status}: ${errorText}`);
  }

  return await res.json();
}
